module.exports = __webpack_public_path__ + "img/cancal.0517d91b.png";